<template>
  <div>
    <div class="sortTable">
      <div class="handlerTableBox">
        <div class="handlerSort">
          <label class="labelS">签署顺序：</label>
          <el-radio-group v-model="orderType" fill="E88078" @change="radioChange">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
          <span v-if="orderType=='1'" class="drapTip">（按住鼠标左键拖动调整签署顺序）</span>
        </div>
        <div class="handlerSort"></div>
        <div class="handlerTableInfor">
          <div
            @click="addSignPerson"
            class="handlerButton cursorPointer addSignPerson addSignPersonActive"
          >
            <span></span>添加个人签署方
          </div>
          <!-- <div
            @click="addSignPerson"
            class="handlerButton cursorPointer addSignPerson addSignPersonActive"
          >
            <span></span>添加签署方
          </div> -->
          <div
            @click="addSignEnpres"
            class="handlerButton cursorPointer addSignPerson addSignPersonActive addSignEn"
          >
            <span></span>添加企业签署方
          </div>
          <div @click="addOtherSignPerson" class="handlerButton cursorPointer addSignPerson">
            <span></span>从联系人添加
          </div>
        </div>
      </div>
      <div v-show="showTable && signContractTipData.length">
        <el-table
          :data="signContractTipData"
          style="width: 100%;"
          class="sortAbled"
          type="index"
          row-key="signatoryId"
          header-cell-class-name="cellCustomer headerCellCustomer ft14"
          :cell-class-name="tableRowClassName"
        >
          <el-table-column width="100px" label="签署顺序" v-if="orderType==1">
            <template slot-scope="scope">{{scope.row.index}}</template>
          </el-table-column>
          <el-table-column width="100px" label="签约方">
            <template slot-scope="scope">
              <template v-if="scope.row.type">
                <div v-show="scope.row.type==1">个人</div>
                <div v-show="scope.row.type==2">企业</div>
              </template>
               <template v-else>
                <div >个人</div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="account" label="手机/邮箱"></el-table-column>
          <el-table-column prop="userName" label="姓名/企业名称"></el-table-column>
          <el-table-column  label="签约支付费用" v-if="paymentTypeVlaue=='2'">
            <template slot-scope="scope">
               <InputPrice :signatoryId="scope.row.signatoryId" :amount="scope.row.amount" @setPrcieVal="setPrcieVal" :curIndex="scope.row.index"></InputPrice>
            </template>
          </el-table-column>
          <el-table-column label="实名状态">
            <template slot-scope="scope">
              <div v-show="scope.row.realNameStatus==1">
                <span class="auth authFlag"></span>
                已实名
              </div>
              <div v-show="scope.row.realNameStatus==2">
                <span class="noAuth authFlag"></span>
                未实名
              </div>
            </template>
          </el-table-column>

          <!-- 1-线上签署、2-线下签署 -->
          
          <el-table-column label="签署方式" v-if="flag">
            <template slot-scope="scope" >
              <span v-if="$store.state.currentInfo.enterpriseName==scope.row.userName">
                <el-select v-model="scope.row.offlineSign" placeholder="请选择" size="mini" @change="offlineSignChange()">  
                  <el-option
                    label="线上签署"
                    :value="false"
                    :key="1">
                  </el-option>
                  <el-option
                    label="线下签署"
                    :value="true"
                    :key="2">
                  </el-option>
                </el-select>
              </span>
              <!-- <span v-else>{{offlineSign?'线上签署':"线下签署"}}</span> -->
              <span v-else>线上签署</span>
            </template>
          </el-table-column>
          <el-table-column prop="concatState" label="操作" width="150px">
            <template slot-scope="scope">
              <div class="handlerBoxCenter">
                <img
                  class="cursorPointer"
                  @click="deleteItem(scope.row)"
                  src="@image/personalSign/delete_icon_hov.png"
                >
                <img class="cursorPointer" src="@image/personalSign/drag_icon_hov.png">
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-table
        :data="addCustomer"
        style="width: 100%;margin-bottom:10px;"
        row-key="signatoryId"
        v-if="showAdd"
        class="notSortAbled"
        header-cell-class-name="cellCustomer headerCellCustomer ft14"
        :cell-class-name="tableRowClassName"
      >
        <el-table-column type="index" width="100px" label="签署顺序" v-if="orderType==1">
          <template slot-scope="scope" v-if="!scope.row.add">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="id" width="100px" label="签约方"></el-table-column>
        <el-table-column prop="concatName" label="手机/邮箱">
          <template slot-scope="scope">
            <el-input
              class="elInputCustomer"
              v-if="scope.row.add==true"
              v-model="personFlag"
              @blur="savePerson"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="launchName" label="姓名/企业名称"></el-table-column>
        <el-table-column prop="signDateStart" label="实名状态">
          <template slot-scope="scope">
            <div :style="{'margin-left':paymentTypeVlaue=='2'?'48px':'0px'}">
              <span class="noAuth authFlag"></span>
              未实名
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="signDateStart" label="签署方式" v-if="flag">
          
        </el-table-column>
        <el-table-column prop="concatState" label="操作" width="150px">
          <template slot-scope="scope">
            <div class="handlerBoxCenter">
              <img
                class="cursorPointer"
                @click="hideAdd"
                src="@image/personalSign/delete_icon_hov.png"
              >
              <img class="cursorPointer" src="@image/personalSign/drag_icon_hov.png">
            </div>
          </template>
        </el-table-column>
      </el-table>
      <Dialog
        :visible="signListShow"
        :dialogTitle="'添加签署方'"
        :width="'680px'"
        @closeDialog="closeDialog('signListShow')"
      >
        <div class="signListDialog" slot="dialog">
          <div class="searchBarRight">
            <el-input class="contractName" v-model="searchContractName" placeholder="手机号/邮箱"></el-input>
            <span @click="searchContractNameChange" class="searchIcon cursorPointer"></span>
          </div>
          <sign-other-list :tableData="otherList" ref="otherList"></sign-other-list>
          <div class="authHandlerBox" style="margin:0 auto">
            <div class="button cursorPointer buttonActive" @click="getCheckList">确定</div>
            <div class="button cursorPointer" @click="closeDialog('signListShow')">取消</div>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="signMShow"
        :dialogTitle="'添加企业签署方'"
        :width="'380px'"
        @closeDialog="closeDialog('signMShow')"
      >
        <div class="signListDialog signMShowBox" style="width:380px;" slot="dialog">
          <div class="searchBarRight signMShow">
            <p style="font-size:12px;margin-bottom:10px;">请输入企业名称：</p>
            <el-input class="contractName"  v-model="searchEnname" placeholder="请输入已实名的企业名称"></el-input>
          </div>
          <div class="authHandlerBox" style="margin:0 auto;margin-top:40px;">
            <div class="button cursorPointer" @click="closeDialog('signMShow')">取消</div>
            <div class="button cursorPointer buttonActive" @click="addEnitemFn">确定</div>
          </div>
        </div>
      </Dialog>
    </div>
  </div>
</template>
<script>
import Sortable from "sortablejs";
import Reg from "@lib/reg.js";
import BaseApi from "@lib/baseApi.js";
import signOtherList from "./signOtherList.vue";
import Dialog from "@common/Dialog.vue";
import InputPrice from "./inputPrice.vue";
import { mapGetters ,mapState} from "vuex";
export default {
  name:"signContract_sortTable",
  props: ["dataList", "powerId","paymentTypeVlaue"],
  data() {
    return {
      orderType: "1",
      showAdd: false,
      sortTableEl: null,
      personFlag: "",
      signContractTipData: [],
      signListShow: false,
      otherList: [],
      searchContractName: "",
      showTable: true,
      signPricesData:[],
      signMShow:false,
      searchEnname:"",
      addCustomer: [
        {
          userName: "",
          realNameType: "",
          overplusDays: "",
          id: "",
          add: true
        }
      ],
      signPriceVal:"",
      paymentTypeVlaue:"",
      signPriceSum:0,
      signPriceItem:0,
      isShowAdds:0,//显示，满足
      flag:process.env.VUE_APP_OFFLINESIGN_FLAG // 签署方式开关
    };
  },
  mounted() {
    this.rowDrop();
    this.getCurrentSign();
      // console.log(this.dataList,this.getCurInfo)
  },
  components: {
    signOtherList,
    Dialog,
    InputPrice
  },
  created() {
    
    if (this.dataList) {
      this.signContractTipData = this.dataList;
    }
    console.log(this.signContractTipData, 'signContractTipDatasignContractTipData')
    this.getVAL();
  },
  computed: {
    ...mapState(['currentInfo']),
    ...mapGetters(['getCurInfo','getUserInfo'])
  },
  methods: {
    getCurrentSign(){
       let newCur;
       let type;
        //当前显示的
        if(this.getUserInfo.hasOwnProperty("currentUserId")){
          newCur=[...[this.getUserInfo.person],...this.getUserInfo.enterpriseList]
          type=newCur.filter(item=>item.userId==this.getUserInfo.currentUserId)[0];
          if(type.realNameType==1){
            this.newSavePre(type)
          }else{
            this.newSaveEn(type)
          }
        }
    },
    //签约方付费
    setPrcieVal(obj){
      let newArr=[];//去重
      let newArrs=[];//最终数据
      newArr= this.signPricesData.filter((item,ind)=>{
        return item.id==obj.id;
      })
      if(!newArr.length){
        this.signPricesData.push(obj);
      }else{
        this.signPricesData.splice(newArr[0].ind-1,1,obj);
      }
      this.signContractTipData.forEach((item,ind)=>{
        this.signPricesData.forEach((val,curid)=>{
          if(item.signatoryId == val.id){
            this.signContractTipData[ind].amount=val.amount;
            newArrs.splice(ind,1,{id:item.signatoryId,amount:val.amount,ind:val.ind});
          }
        })
      })
      this.signPricesData=newArrs;
      // console.log(this.signPricesData,this.getPriceSum(newArrs),this.signPriceSum);
      if(this.signPricesData.length == this.signContractTipData.length){
        if(this.getPriceSum(newArrs)>(this.signPriceSum-0)){
          this.$message.error("签约支付费用超出该合同费用");
        }else if(this.getPriceSum(newArrs)<(this.signPriceSum-0)){
          this.$message.error("签约支付费用少于该合同费用");
        }
      }
    },
    //求和
    getPriceSum(arr){
      var s = 0;
      for (var i=0; i<arr.length; i++) {
        s += arr[i].amount?(arr[i].amount-0):0;
      }
      return s;
    },
     // 获取合同需要的价钱
    getContractAmount() {
      BaseApi.createRpcToken("/pay/getContractAmount", {
        count:this.signContractTipData.length
      }).then(
          data => {
            this.signPriceSum=data.datas.amount;//总价格
            this.$bus.emit('priceSumval',data.datas.amount);//获取总价
            let amounts=(this.signPriceSum-0)/this.signContractTipData.length;
            this.signPriceItem=amounts+''.indexOf('.')==-1?amounts:amounts.toFixed(2);//单价
            this.signContractTipData.forEach((item)=>{
                item.amount= amounts+''.indexOf('.')==-1?amounts:amounts.toFixed(2)
            })
            if(this.signPriceSum.indexOf('.')!=-1){//小数不能被整除
              if(this.getPriceSum(this.signContractTipData) == (this.signPriceSum-0)){
                this.isSumC=true;
              }else{
                this.isSumC=false;
              }
            }else{
              if((this.signPriceSum-0) % this.signContractTipData.length === 0){
                this.isSumC=true;
              }else{
                if(this.getPriceSum(this.signContractTipData) == (this.signPriceSum-0)){
                  this.isSumC=true;
                }else{
                  this.isSumC=false;
                }
              }
            }
          },
          err => {}
        );
    },
    getVAL(){
      this.$bus.on("paymentTypeValue",(value)=>{
      　　this.paymentTypeVlaue=value;
      });
    },
    //添加企业签署方
    addEnitemFn(){
      BaseApi.createRpcToken("/signatory/v2/enterpriseRealNameValidate", { name: this.searchEnname })
        .then(
          data => {
            if(data.datas.success){
                this.addEnterpriseSignatory(this.searchEnname)
            }else{
               this.$message.error("请输入已实名企业");
            }
          },
          err => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    addEnterpriseSignatory(enName){
      BaseApi.createRpcToken("/signatory/v2/addEnterpriseSignatory", { name: enName }).then(data=>{
        if(data.datas.code==3001){
          if (this.judgeUid(data.datas.signatoryId)) {
            this.signContractTipData.push({
                signatoryId: data.datas.signatoryId,
                type:"2",
                account: data.datas.mobile || data.datas.mail,
                userName: enName,
                realNameStatus: "1",
                offlineSign:process.env.VUE_APP_OFFLINESIGN_FLAG?false:''
              });
                this.addIndex(this.signContractTipData)
            this.personFlag = "";
            this.signMShow=false;
            this.searchEnname=""
          } else {
            this.$message.error("不能添加相同的签署方");
          }
        }else if(data.code==3021){
         
        }else if(!data.datas.code){
          if (this.judgeUid(data.datas.signatoryId)) {
            this.signContractTipData.push({
              signatoryId: data.datas.signatoryId,
              type:"2",
              account: data.datas.mobile || data.datas.mail,
              userName: this.searchEnname,
              realNameStatus: "1"
            });
            this.addIndex(this.signContractTipData)
            this.personFlag = "";
            this.signMShow=false;
              this.searchEnname=""
          } else {
            this.$message.error("不能添加相同的签署方");
          }
        }else{
            this.$message.error(data.datas.message); 
        }
      },data=>{
        if(data.code==3021){
        }
      })
    },
    setData(data) {
      let tempArr = [];
      data.forEach((value, index) => {
        let temp = {
          userName: value.name,
          realNameType: value.type,
          type: value.type,
          realNameStatus: value.realNameStatus == 0 ? 2 : 1,
          account: value.mobile || value.mail,
          signatoryId: value.id,
          signOrderNum: value.signOrderNumm,
          index: index + 1,
          offlineSign:process.env.VUE_APP_OFFLINESIGN_FLAG?false:''
        };
        tempArr.push(temp);
      });
      this.signContractTipData = tempArr.sort(function(a, b) {
        return a.signOrderNum - b.signOrderNum;
      });
    },
    rowDrop(disabled = false) {
      const tbody = document.querySelector(
        ".sortAbled .el-table__body-wrapper tbody"
      );

      const _this = this;
      this.sortTableEl = Sortable.create(tbody, {
        disabled: disabled,
        onFilter: function(evt) {
          var itemEl = evt.item;
        },
        onEnd({ newIndex, oldIndex }) {
          let temp = _this.signContractTipData.concat();
          _this.changePosition(_this.signContractTipData, oldIndex, newIndex);
          _this.addIndex(_this.signContractTipData);
          return false;
        }
      });
      $(tbody).on("drop", e => {
        e.stopPropagation();
        e.preventDefault();
      });
    },
    changePosition(arr, index, tindex) {
      if (index > tindex) {
        if (tindex - 1 > 0) {
          arr.splice(tindex - 1, 0, arr[index]);
          this.$forceUpdate();
        } else {
          arr.unshift(arr[index]);
          this.$forceUpdate();
        }
        arr.splice(index + 1, 1);
      } else {
        if (tindex + 1 == arr.length) {
          arr.push(arr[index]);
          this.$forceUpdate();
        } else {
          arr.splice(tindex + 1, 0, arr[index]);
          this.$forceUpdate();
        }
        arr.splice(index, 1);
        this.$forceUpdate();
      }
    },
    addIndex(data) {
      if (data && data.length) {
        data.forEach((value, index) => {
          value.index = index + 1;
        });
      }
    },
    closeDialog(flag) {
      this[flag] = false;
      this.searchEnname=""
    },
    tableRowClassName(data) {
      return "cellCustomer ft12";
    },
    getCheckList() {
      let list = this.$refs.otherList.getCheckList();
      let listTemp = [];
      if(process.env.VUE_APP_OFFLINESIGN_FLAG){
        list.map(value => {
            if (this.judgeUid(value.id)) {
              this.signContractTipData.push({
                signatoryId: value.id,
                type: value.type,
                amount:'',
                account: value.mobile || value.mail,
                userName: value.name,
                realNameStatus: value.really == 0 ? 1 : 2,
                offlineSign:process.env.VUE_APP_OFFLINESIGN_FLAG?false:''
              });
            }
          });
          this.addIndex(this.signContractTipData);
          this.signListShow = false;
      }else{
        if(this.signContractTipData.length<2 && list.length==1){
          list.map(value => {
            if (this.judgeUid(value.id)) {
              this.signContractTipData.push({
                signatoryId: value.id,
                type: value.type,
                amount:'',
                account: value.mobile || value.mail,
                userName: value.name,
                realNameStatus: value.really == 0 ? 1 : 2,
              });
            }
          });
          this.addIndex(this.signContractTipData);
          this.signListShow = false;
        }else{
          this.$message.error("仅支持两方签署");
        }

      }
    },
    radioChange() {
      this.sortTableEl.destroy();
      if (this.orderType == 1) {
        this.rowDrop(false);
      } else {
        this.rowDrop(true);
      }
    },
    savePerson(flag, data) {
      let queryParams = {
        mail: "",
        mobile: "",
        handleType: "1",
        partnerId: "13",
      };
      if (flag == "addNormal") {
        if (this.signContractTipData.length == 0 && !this.addFlag) {
          this.addFlag = true;
          queryParams.mobile = data.mobile;
          queryParams.mail = data.mail;
          this.addSign(queryParams);
        }
      } else {
        if (this.personFlag) {
          if (Reg.PHONE.test(this.personFlag)||Reg.PHONE_TEST.test(this.personFlag)) {
            queryParams.mobile = this.personFlag;
          } else if (Reg.EMAIL.test(this.personFlag)) {
            queryParams.mail = this.personFlag;
          } else {
            this.$message.error("格式错误");
            return;
          }
          this.addSign(queryParams);
        }
      }
    },
    judgeCanAdd(flag) {
      for (let i = 0; i < this.signContractTipData.length; i++) {
        if (this.signContractTipData[i].account == flag) {
          return false;
        }
      }
      return true;
    },
    judgeUid(signatoryId) {
      for (let i = 0; i < this.signContractTipData.length; i++) {
        if (this.signContractTipData[i].signatoryId == signatoryId) {
          return false;
        }
      }
      return true;
    },
    addSign(queryParams) {
      if (this.judgeCanAdd(queryParams.mobile || queryParams.mail)) {
        this.powerId && (queryParams.userId = this.powerId);
        BaseApi.createRpcToken("/signatory/queryUserName", queryParams)
          .then(
            data => {
              if(data.datas.resultList){
                let resultList = data.datas.resultList;
                if(process.env.VUE_APP_OFFLINESIGN_FLAG){
                  resultList[0].offlineSign=false
                }
            
                if (resultList[0].id) {
                  if (this.judgeUid(resultList[0].id)) {
                    resultList[0].signatoryId = resultList[0].id;
                    resultList[0].account =
                      queryParams.mobile || queryParams.mail;
                    resultList[0].userName = resultList[0].name;
                    resultList[0].amount=""
                    this.signContractTipData.push(resultList[0]);
                    this.addIndex(this.signContractTipData);
                    this.personFlag = "";
                  } else {
                    this.$message.error("不能添加相同的签署方");
                  }
                } else {
                  resultList[0].name && (queryParams.name = resultList[0].name);
                  resultList[0].type && (queryParams.type = resultList[0].type);
                  resultList[0].signUserId &&
                    (queryParams.signUserId = resultList[0].signUserId);
                  this.powerId && (queryParams.userId = this.powerId);
                  BaseApi.createRpcToken(
                    "/signatory/addSignatory",
                    queryParams,
                    "post"
                  )
                    .then(
                      data => {
                        if (this.judgeUid(data.datas.signatoryId)) {
                          data.datas.account =
                            queryParams.mobile || queryParams.mail;
                          data.datas.realNameStatus =
                            resultList[0].realNameStatus;
                            data.datas.amount=""
                          data.datas.userName = resultList[0].name;
                          data.datas.type = resultList[0].type;
                          this.signContractTipData.push(data.datas);
                          this.addIndex(this.signContractTipData);
                          this.personFlag = "";
                        } else {
                          this.$message.error("不能添加相同的签署方");
                        }
                      },
                      () => {}
                    )
                    .catch(function(e) {
                      errorLog(e);
                    });
              }
             }else{
               
             }
            },
            error => {
            }
          )
          .catch(function(e) {
            errorLog(e);
          });
          
      } else {
        this.$message.error("不能添加相同的签署方");
      }
    },
    deleteItem(row, index) {
      for (let i = 0; i < this.signContractTipData.length; i++) {
        if (row.signatoryId == this.signContractTipData[i].signatoryId) {
          this.signContractTipData.splice(i, 1);
        }
      }
      this.addIndex(this.signContractTipData);
       this.getContractAmount();
    },
    hideAdd() {
      this.showAdd = false;
    },
    addSignPerson() {
      let dom = document.querySelector('.el-table__empty-block')
      if(dom){
        dom.style.display = 'none'
      }
      if(process.env.VUE_APP_OFFLINESIGN_FLAG){
        this.showAdd = true;
        this.isShowAdds=1;
      }else{
        if(this.signContractTipData.length<2){
          this.showAdd = true;
          this.isShowAdds=1;
        }else{
          this.showAdd = false;
          this.isShowAdds=0;
          this.$message.error("仅支持两方签署");
        }

      }
    },
    //添加企业签署方
    addSignEnpres(){
      if(process.env.VUE_APP_OFFLINESIGN_FLAG){
        this.signMShow = true;
      }else{
        if(this.signContractTipData.length<2){
          this.signMShow = true;
        }
        else{
          this.signMShow = false;
          this.$message.error("仅支持两方签署");
        }

      }
    },
    searchContractNameChange() {
      let params = { userInput: "" };
      if (Reg.PHONE.test(this.searchContractName)) {
        params.userInput = this.searchContractName;
      } else if (Reg.EMAIL.test(this.searchContractName)) {
        params.userInput = this.searchContractName;
      } else {
        this.$message.error("输入邮箱或者手机号错误");
        return;
      }
      this.addOtherSignPerson(params);
    },
    addOtherSignPerson(params) {
      let paramsTemp = {
        userInput: params.userInput,
        isTrusted: true,
        userId: this.powerId
      };
      BaseApi.createRpcToken("/signatory/signatoryList", paramsTemp)
        .then(
          data => {
            // 不应该显示禁用的list
            if (data.datas.list.length) {
              this.otherList = data.datas.list.filter(value => {
                return value.enabled == 1;
              });
            } else {
              this.otherList = [];
            }
            if(process.env.VUE_APP_OFFLINESIGN_FLAG){
              this.signListShow = true;
            }else {
              if(this.signContractTipData.length<2){
                this.signListShow = true;
              }else{
                this.signListShow = false;
                this.$message.error("仅支持两方签署");
              }
            }
          },
          () => {
            this.signListShow = true;
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    save() {
      if (this.personFlag) {
        if (!Reg.PHONE.test(this.personFlag)&&!Reg.PHONE_TEST.test(this.personFlag)&&!Reg.EMAIL.test(this.personFlag)) {
          return {
            valid: false,
            validMessage: "格式错误",
          };
        }
      }     
      let listTemp = [];
      let signatoryAmountList=[];
      let newArr=[]
      this.signContractTipData.forEach(function(value) {
        listTemp.push(value.signatoryId);
        newArr.push({id:value.signatoryId,amount:0});
      });
       this.signContractTipData.forEach((item,ind)=>{
        this.signPricesData.forEach((val,curid)=>{
          if(item.signatoryId == val.id){
            newArr.splice(ind,1,{id:item.signatoryId,amount:val.amount})
          }
        })
      })
      signatoryAmountList=Array.from(new Set(newArr));
      if(this.paymentTypeVlaue==2){
        //  console.log(signatoryAmountList,"231231231231",)
        if(this.getPriceSum(signatoryAmountList)>(this.signPriceSum-0)){
          return {
            data: listTemp,
            orderType: this.orderType,
            valid: true,
            isValyes:1,//不能提交
            signatoryAmount:signatoryAmountList
          };
        }else if(this.getPriceSum(signatoryAmountList)<(this.signPriceSum-0)){
          return {
            data: listTemp,
            orderType: this.orderType,
            valid: true,
            isValyes:0,//不能提交
            signatoryAmount:signatoryAmountList
          };
        }else if(this.getPriceSum(signatoryAmountList)==(this.signPriceSum-0)){
          return {
            data: listTemp,
            orderType: this.orderType,
            valid: true,
            isValyes:2,//可提交
            signatoryAmount:signatoryAmountList
          };
        }
      }else{
          return {
            data: listTemp,
            orderType: this.orderType,
            valid: true,
         }
      }
      // if (listTemp.length > 1) {
      // return {
      //   data: listTemp,
      //   orderType: this.orderType,
      //   valid: true
      // };
      // } else {
      //   return {
      //     data: [],
      //     valid: false,
      //     validMessage: "至少选择两个签署方"
      //   };
      // }
    },
    //默认个人签署
    newSavePre(datasCur){
      let queryParams = {
        mail: "",
        mobile: "",
        handleType: "1",
        partnerId: "1"
      };
      queryParams.mobile = datasCur.mobile;
      queryParams.mail = datasCur.mail;
      let Arrindex=this.signContractTipData.filter((item,index)=>item.userName==datasCur.realName)[0]
      let index=this.signContractTipData.indexOf(Arrindex)
      // if(index==0){
        
      // }else{
      //   this.signContractTipData.splice(index-1,1)
      // }
    
      BaseApi.createRpcToken("/signatory/queryUserName", queryParams)
      .then(
      data => {
         this.signContractTipData.splice(Arrindex,1)
        let resultList = data.datas.resultList;
         this.addIndex(this.signContractTipData);
         if( resultList[0].id){
            if (this.judgeUid(resultList[0].id)) {
            resultList[0].signatoryId = resultList[0].id;
            resultList[0].account =
              queryParams.mobile || queryParams.mail;
              resultList[0].amount='';
            resultList[0].userName = resultList[0].name;
            this.signContractTipData.push(resultList[0]);
            this.addIndex(this.signContractTipData);
            this.personFlag = "";
          }else{
          }
         }else{
           
           BaseApi.createRpcToken(
                  "/signatory/addSignatory",
                  queryParams,
                  "post"
                )
                  .then(
                    data => {
                      if (this.judgeUid(data.datas.signatoryId)) {
                        resultList[0].signatoryId = data.datas.signatoryId;
                        resultList[0].account =
                          queryParams.mobile || queryParams.mail;
                           resultList[0].amount='',
                        resultList[0].userName = resultList[0].name;
                        this.signContractTipData.push(resultList[0]);
                        this.addIndex(this.signContractTipData);
                        this.personFlag = "";
                      } else {
                        this.$message.error("不能添加相同的签署方");
                      }
                    },
                    () => {}
                  )
                  .catch(function(e) {
                    errorLog(e);
                  });
         }
         
      })
         
    },
    //默认企业签署
    newSaveEn(datasCur){
      let Arrindex=this.signContractTipData.filter((item,index)=>item.userName==datasCur.realName)[0]
      let index=this.signContractTipData.indexOf(Arrindex)
      // if(index==0){
      //   this.signContractTipData.splice(index+1,1)
      // }else{
      //   this.signContractTipData.splice(index-1,1)
      // }
      this.signContractTipData.splice(Arrindex,1)
      BaseApi.createRpcToken("/signatory/v2/addEnterpriseSignatory", { name: datasCur.realName }).then(data=>{
         this.addIndex(this.signContractTipData);
        if(data.datas.code==3001){
          if (this.judgeUid(data.datas.signatoryId)) {
            this.signContractTipData.push({
              signatoryId: data.datas.signatoryId,
              type:"2",
              account: "",
              amount:'',
              userName: datasCur.realName,
              realNameStatus: "1",
              offlineSign:false
            });
               this.personFlag = "";
            this.signMShow=false;
            this.searchEnname=""
          }
        }else{
           if (this.judgeUid(data.datas.signatoryId)) {
            this.signContractTipData.push({
              signatoryId: data.datas.signatoryId,
              type:"2",
               amount:'',
              account: data.datas.mobile || data.datas.mail,
              userName: datasCur.realName,
              realNameStatus: "1"
            });
            this.addIndex(this.signContractTipData)
            this.personFlag = "";
            this.signMShow=false;
            this.searchEnname=""
          }
        }
      },data=>{
        
      })
    },
    offlineSignChange(){
        this.$forceUpdate()
    }
  },
  watch:{
    "currentInfo"(datasCur){
      if(datasCur.realNameType==1){
        this.newSavePre(datasCur)
      }else{
        this.newSaveEn(datasCur)
      }
    },
    "paymentTypeVlaue"(data){
    },
    'signContractTipData'(){
      this.getContractAmount();
      if(this.signContractTipData.length<2 && this.isShowAdds==1){
        this.showAdd=true;
      }else{
        this.showAdd=false;
      }
    },
   
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.signMShow{
   .el-input__inner {
    text-align:left !important;
    font-size:12px;
    margin-bottom:40px;
    width:340px !important;
  }
}
.elInputCustomer {
  .el-input__inner:focus {
    border-color: #D81212;
    outline: 0;
  }
  .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}
.notSortAbled {
  .el-table__header-wrapper {
    display: none;
  }
}
.signMShowBox{
  border-radius:0px 0px 10px 10px;
}
.signListDialog {
  width: 680px;
  box-sizing: border-box;
  background-color: white;
  padding: 20px;
  .el-table {
    min-width: 360px !important;
  }
  .searchBarRight {
    margin-bottom: 10px;
    .contractName {
      width: 300px;
      height: 30px;
      .el-input__inner {
        width: 300px;
        height: 30px;
        text-align: center;
      }
    }
    .searchIcon {
      display: inline-block;
      margin-left: 10px;
      vertical-align: top;
      width: 30px;
      height: 30px;
      background: url(./../../../../../assets/images/personalSignHome/search_icon_nor.png);
      background-size: 100%;
    }
    .searchIcon:hover {
      background: url(./../../../../../assets/images/personalSignHome/search_icon_pre.png);
    }
  }
}
.signPrices{
  border: 1px solid #E4E8EB;
border-radius: 2px;
width: 108px;
height: 28px;
}
  .signPrices::-webkit-outer-spin-button,
        .signPrices::-webkit-inner-spin-button{
            -webkit-appearance: none !important;
            margin: 0; 
        }
.handlerTableBox {
  .drapTip {
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #c8c8c8;
    line-height: 12px;
    margin-left: 10px;
  }
  display: flex;
  margin-bottom: 10px;
  justify-content: space-between;
  .handlerSort {
    line-height: 45px;
    .labelS {
      font-size: 12px;
      color: #969696;
      margin-right: 10px;
    }
    .el-radio__label {
      font-size: 12px;
      color: #969696;
      padding-left: 10px;
    }
    .is-focus .el-radio__input .el-radio__inner {
      border: 1px solid #dcdfe6;
    }
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #e88078;
      background: #e88078;
    }
  }
  .handlerTableInfor {
    display: flex;
    justify-content: space-around;
    width: 580px;
    height: 45px;
    .handlerButton {
      &:hover {
        color: #646464;
        border-color: #646464;
        background-color: rgb(248, 248, 248);
        span {
          background: url("./../../../../../assets/images/personalSign/system-addcopy4.png");
        }
      }
      color: #787878;
      font-size: 14px;
      text-align: center;
      width: calc(50% - 20px);
      line-height: 43px;
      // background: #fafafa;
      border: 1px dashed #c8c8c8;
    }
    .addSignPerson {
      span {
        display: inline-block;
        height: 14px;
        width: 14px;
        vertical-align: baseline;
        margin-bottom: -2px;
        margin-right: 20px;
        background: url(./../../../../../assets/images/personalSign/add_contacts_icon_nor.png);
      }
    }
    .addSignEn{
      margin:0px 20px;
    }
    .addSignPersonActive {
      border: 1px dashed #db4437;
      color: #db4437;
      background-color: rgb(252, 252, 252);
      &:hover {
        color: #c22315;
        border-color: #c22315;
        background-color: rgb(248, 248, 248);
        span {
          background: url("./../../../../../assets/images/personalSign/Shape.png");
        }
      }
      span {
        background: url(./../../../../../assets/images/personalSign/add_signer_icon_hov.pre.png);
      }
    }
  }
}
.sortTable {
  margin-bottom: 10px;
  .noAuth {
    background: url(./../../../../../assets/images/personalSign/no_real_icon.png);
  }
  .authFlag {
    width: 14px;
    height: 14px;
    margin-right: 6px;
    background-size: 100%;
    display: inline-block;
    vertical-align: middle;
  }
  .auth {
    background: url(./../../../../../assets/images/personalSign/have_real_icon.png);
  }
  .addRow {
    background-color: #fff7f7;
  }
  overflow-x: auto;
  .mainColor {
    color: #e88078;
  }
  .el-table {
    min-width: 1080px;
  }
  .cellCustomer {
    height: 48px;
    text-align: center;
    line-height: 48px;
    padding: 0;
    color: #969696;
  }
  .headerCellCustomer {
    color: #505050;
    background-color: #f9f9f9;
  }
  .handlerBox {
    display: flex;
    justify-content: space-between;
  }
  .handlerBoxCenter {
    display: flex;
    justify-content: space-around;
  }
  .tableFooter {
    text-align: right;
    padding-right: 48px;
    color: #646464;
  }
}

</style>
